module.exports = __webpack_public_path__ + "img/Sophia-Cannizzaro.378162e3.jpeg";